import React, { useEffect, useState } from 'react'
import { Spinner } from '../../../base-components'
import style from './e3dLoadingSpinner.css'

type Props = {
  isLoading: boolean
  is3DExhibitionEnabled: boolean
}

const E3DLoadingSpinner: React.FC<Props> = ({ isLoading, is3DExhibitionEnabled}) => {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    setVisible(isLoading)
  }, [isLoading])

  if (!visible || !is3DExhibitionEnabled) {
    return null
  }

  return (
    <div className={style.e3dLoadingSpinnerOverlay} data-testid="e3d-loading-spinner">
      <div className={style.e3dLoadingSpinnerContainer}>
        <Spinner width="60px" height="60px" />
      </div>
    </div>
  )
}

export default E3DLoadingSpinner
